/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Zip/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Zip({
  children,
  viewPath = "/DesignSystem/SyncPatientMatchingCard/Zip"
  
}) {
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let cardMatchZipValueData = fromData.useDataValue({ viewPath,
context: 'card',
path: 'match.zip',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsRed900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.900'
        })
let cardPatientZipValueData = fromData.useDataValue({ viewPath,
context: 'card',
path: 'patient.zip',
})
let constantData = 'N/A'
let aggregateData = fromAggregate.any(cardPatientZipValueData, constantData)
let cardMatchZipValueData1 = fromData.useDataValue({ viewPath,
context: 'card',
path: 'match.zip',
})
  return (<React.Fragment
>
<div
  data-testid="Zip.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-o94': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 text="ZIP"
 color={!cardMatchZipValueData ? dtColorsRed900 : dtColorsNeutral900}
 data="card.match.zip"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={!cardMatchZipValueData1 ? dtColorsRed900 : dtColorsNeutral900}
 size="small"
 data="card.patient.zip"
 data="'N/A'"
 aggregate="/Simple/Data/aggregate.js any"
 text={aggregateData}
 data="card.match.zip"
/>
</div>
{children}
</React.Fragment>)
}